import { Component, OnInit, AfterViewInit, ElementRef, ViewChild, HostListener } from '@angular/core';
import { QuestionnaireService, Group, Question, Option, Answer } from '../../services/questionnaire.service';
import { MatRadioModule } from '@angular/material/radio';
import { FormsModule } from '@angular/forms';
import { CommonModule, NgIf } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { MessageModalComponent } from '../message-modal/message-modal.component';
import { Router } from '@angular/router';
import { OauthService } from '../../services/oauth.service';
import { ActivatedRoute } from '@angular/router';
import { AppContext, ContextService } from '../../services/context.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-questionnaire',
  imports: [FormsModule, CommonModule, NgIf],
  templateUrl: './questionnaire.component.html',
  styleUrls: ['./questionnaire.component.css']
})

export class QuestionnaireComponent implements OnInit{

  groups: Group[] = [];
  questions: Question[] = [];
  answers: { [key: number]: any[] } = {};
  optionTextAnswers: { [key: number]: string } = {};
  currentQuestionIndex = 0;
  peopleid: string = "";
  journal: string = "" ;
  questionnaireId: string = "";
  years: number[] = [];
  currentGroup: number = 1;
  beginQuestionnaire = false;
  declineQuestionnaire = false;
  showIntro = true;
  submitted = false;
  loading$!: Observable<boolean>;


  constructor(private questionnaireService: QuestionnaireService, 
              private router: Router,
              private oauth: OauthService,
              private contextService: ContextService,
              private route: ActivatedRoute) {
                this.loading$ = this.oauth.loading$;
              }


  completedSteps: number[] = [0]; // store completed step indexes

  currentStepIndex = 0;

  navStuck = false;

  @ViewChild('navProgress') navProgressRef?: ElementRef<HTMLElement>;

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    if (this.navProgressRef) {
      this.navStuck = this.navProgressRef.nativeElement.getBoundingClientRect().top <= 0;
    }
  }

  ngOnInit(): void {

    console.log('inside ngOnInit of LandingPageComponent');

    if (!this.contextService.hasContext()) {

      this.route.queryParamMap.subscribe(params => {

        const context = {
          journalCode: params.get('journal'),
          peopleIdentifier: params.get('peopleIdentifier'),
          questionnaireId: params.get('questionnaireId'),
          role: params.get('role')
        };


        if (!context.journalCode || !context.peopleIdentifier || !context.questionnaireId) {
          console.log("context", context);
          console.log('Missing journalCode/peopleIdentifier/questionnaireId in request!');
          return;
        }

        this.questionnaireId = context.questionnaireId;

        // Prevent redirect loop
        if (!params.get('code') && !params.get('error')) {
          console.log('Starting OAuth for context:', context);
          this.oauth.startOAuth(context);
        }

      });
    }
  }


  begin(){

    const ctx = this.contextService.getContext();

    if (!ctx) {
      console.error('Missing application context');
      return;
    }

    this.journal = ctx.journalCode;
    this.peopleid = ctx.peopleIdentifier; 
    this.questionnaireId = ctx.questionnaireId;

    console.log('Journal:', ctx.journalCode);
    console.log('Person:', ctx.peopleIdentifier);

    // Generate the years from 1940 to the current year
    const currentYear = new Date().getFullYear();
    this.years = [];
    for (let year = 1940; year <= currentYear; year++) {
      this.years.push(year);
    }
    console.log("just before load questions");
    this.loadQuestions();
    this.beginQuestionnaire = true;
    this.showIntro = false;
    console.log("begin " + this.beginQuestionnaire);
  }

  // Decline the form (move to a different screen)
  decline(): void {
    this.declineQuestionnaire = true; // Show the decline message
    this.showIntro = false;
    const ctx = this.contextService.getContext();

    if (!ctx) {
      console.error('Missing application context');
      return;
    }

    this.journal = ctx.journalCode;
    this.peopleid = ctx.peopleIdentifier; 
    this.questionnaireId = ctx.questionnaireId;

    console.log('Journal:', ctx.journalCode);
    console.log('Person:', ctx.peopleIdentifier);
    this.questionnaireService.saveAttempt(this.peopleid, this.journal, this.questionnaireId, this.declineQuestionnaire).subscribe(response => {
      
        if ([200, 201].includes(response.status)){
          // alert('Answers submitted successfully!');
          console.log('Your response was successfully saved! You can now close this window.');
        }
        else{
          //alert('Something went wrong! Please try again later.')
          console.log('Something went wrong! Please try again later.');
        }
      });
  }

  loadQuestions() {

    let counter:number = 0;
    this.questionnaireService.getQuestions(this.peopleid, this.journal, this.questionnaireId).subscribe((data) => {
      
      //console.log("answers from server: " + JSON.stringify(data.answers));
      //console.log("groups: " + JSON.stringify(data.groups));
      this.groups = data.groups.sort((a, b) => a.order - b.order);
      this.groups.forEach(group =>{
        //group.id = ++counter;
        group.questions = group.questions.sort((a: { display_order: number; }, b: { display_order: number; }) => a.display_order - b.display_order);
        group.questions.forEach((q: any) => {
          q.options = q.options.sort((a: { display_order: number; }, b: { display_order: number; }) => a.display_order - b.display_order);
          
        });
      });

      this.answers = data.answers;
      this.optionTextAnswers = data.optionTextAnswers || {};

      //console.log("groups " + JSON.stringify(this.groups));
     
    });
  }

  onOptionSelect(question: Question, option: Option) {

    let exclusiveOptions =  question.options.filter((option: Option) => option.text == "Prefer not to answer");

    let exclusiveOption = exclusiveOptions[0] ?? null;

    if (question.multi_answer) {
      if (!this.answers[question.id]) {
        this.answers[question.id] = []; // Initialize as an empty array
      }
      //console.log("option id " + option.id)
      const index = this.answers[question.id].indexOf(option.id);
      //console.log("index " + index);
      if (index > -1) {
        this.answers[question.id].splice(index, 1); // remove element from array at index
      } else {
        if (option.text == "Prefer not to answer"){
          this.answers[question.id] = [option.id];
        }
        else{
          this.answers[question.id] = this.answers[question.id].filter(id => id != exclusiveOption.id);
          this.answers[question.id].push(option.id);
        }
        
      }
      //console.log("answers: " + JSON.stringify(this.answers));
    } else {
      //console.log('Before:', this.answers);
      this.answers[question.id] = [option.id];
      //console.log('After:', this.answers);
    }
  }

  submitAnswers() {
    //console.log(this.answers);
    const formattedAnswers: Answer[] = Object.keys(this.answers).map(qid => {
      const questionId = Number(qid);
      const optionIds = this.answers[questionId].filter(id => id !== null);
      const textOptionId = optionIds.find(id => !!this.optionTextAnswers[id]);
      const textValue = textOptionId !== undefined ? this.optionTextAnswers[textOptionId] : undefined;

      return {
        question_id: questionId,
        peopleid: this.peopleid,
        journal: this.journal,
        option_ids: optionIds,
        ...(textValue ? { text_value: textValue, text_value_option_id: textOptionId } : {})
      };
    });

    //console.log(JSON.stringify(formattedAnswers));
    this.questionnaireService.submitAnswersAndSaveAttempt(formattedAnswers, this.peopleid, this.journal, this.questionnaireId, this.declineQuestionnaire).subscribe(response => {
      
      if ([200, 201].includes(response.status)){
          //console.log('Answers submitted successfully! ' + response.text);
          this.router.navigate(['/submitted'], { replaceUrl: true });
      }
      else{
        this.router.navigate(['/failure'], { replaceUrl: true });
      }
    });
  }

  next() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    if (this.currentStepIndex < this.groups.length - 1) {
      this.currentStepIndex++;
      this.completedSteps.push(this.currentStepIndex);
      console.log("completedsteps " + this.completedSteps.toString());
    }
    else{
      // last step, submit the form
      this.submitAnswers();
      this.submitted = true;
    }

  }

  prev() {
    if (this.currentStepIndex > 0) {
      this.currentStepIndex--;
    }
  }

  nextButtonText(): string{
    if (this.currentStepIndex < this.groups.length - 1) {
      return  "Continue To " + this.groups[this.currentStepIndex + 1].name;
    }
    return "Submit Questionnaire";
  }

  prevButtonText(): string {
    if (this.currentStepIndex > 0) {
      return "Back To " + this.groups[this.currentStepIndex - 1].name;
    }
    return "";
  }

  goToStep(index: number) {
    if (this.completedSteps.includes(index)){
      this.currentStepIndex = index;
    }
  }

  navAllowed(index: number): boolean{
    if (this.completedSteps.includes(index)){
      return true;
    }
    else{
      return false;
    }
  }

  selectedEduDegree(): boolean{
    let options = [43, 44, 45, 46, 47, 48, 49, 50, 51, 52];
    let selection = this.answers[6]?.[0] ?? -1;
    console.log("Selection " + selection);
    return options.includes(selection);
  }

  onOptionTextChange(option: Option, value: string) {
    this.optionTextAnswers[option.id] = value;
  }

  onTextAnswerChange(question: Question, value: string) {
    if (!this.answers[question.id]) {
      this.answers[question.id] = [];
    }
    this.answers[question.id][0] = value;
  }

  get selectedYear() {
    return this.answers[7]?.[0] ?? "";
  }
  
  set selectedYear(value: any) {
    if (!this.answers[7]) {
      this.answers[7] = [];
    }
    this.answers[7][0] = value;
  }

}
